/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { AnalysisFilterRequestDto } from '../models/AnalysisFilterRequestDto';
import type { CommentCount } from '../models/CommentCount';
import type { PagedCommentsRequestDto } from '../models/PagedCommentsRequestDto';
import type { PagedCommentsResponseDto } from '../models/PagedCommentsResponseDto';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class CommentAnalysisService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param requestBody 
     * @returns PagedCommentsResponseDto Success
     * @throws ApiError
     */
    public getListAsyc(
requestBody?: PagedCommentsRequestDto,
): Observable<PagedCommentsResponseDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/CommentAnalysis/all',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

    /**
     * @param requestBody 
     * @returns CommentCount Success
     * @throws ApiError
     */
    public getSectionAndQuestionCommentCount(
requestBody?: AnalysisFilterRequestDto,
): Observable<Array<CommentCount>> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/CommentAnalysis/get-counts',
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

}
